import { render, staticRenderFns } from "./OrderGeneratorView.vue?vue&type=template&id=0fdb09d8&scoped=true&"
import script from "./OrderGeneratorView.vue?vue&type=script&lang=js&"
export * from "./OrderGeneratorView.vue?vue&type=script&lang=js&"
import style0 from "./OrderGeneratorView.vue?vue&type=style&index=0&id=0fdb09d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdb09d8",
  null
  
)

export default component.exports